import { FC, useEffect } from "react";
import { oneServiceRedirectionFun } from "../../utils/helper";
import { Navigate, useLocation } from "react-router-dom";

const OneServiceRedirection: FC = () => {
  const location = useLocation();
  useEffect(() => {
    oneServiceRedirectionFun(location?.search);
  }, []);

  return <Navigate to={"/oneService"} />;
};

export default OneServiceRedirection;
